module.exports = __webpack_public_path__ + "img/bgc10.b5cc3982.png";